<template>
  <mdb-container class="gp-has-header">
    <div v-if="showMain" class="text-left">
      <mdb-btn icon="plus-circle" @click="newJob">New</mdb-btn>
      <data-table :clickHandler="openJob"
                  :columns="columns"
                  dataSource="/dynamicJob/list"
                  pageTitle="Jobs"/>
    </div>
    <div v-if="showJob">
      <mdb-card class="mb-4">
        <mdb-card-body class="text-left">
          <mdb-btn @click="cancelShow" icon="arrow-left">Back</mdb-btn>
          <mdb-input disabled label="ID" type="text" v-model="currentJob.id"/>
          <gp-select :dataObj="currentJob" :possible-values="validTypes" :required="true" label="Type"
                     propertyName="type"/>

          <mdb-input label="Name" type="text" v-model="currentJob.name"/>
          <mdb-input label="Description" type="text" v-model="currentJob.descr"/>
          <mdb-input v-if="currentJob.type=='GET_AND_PROCESS_ENDPOINTS'" label="GET Endpoint" type="text"
                     v-model="currentJob.getEndpoint"/>
          <mdb-input v-if="currentJob.type !='GROOVY'" label="Process Endpoint" type="text"
                     v-model="currentJob.processEndpoint"/>
          <gp-select :dataObj="currentJob" :possible-values="methods" :required="true" label="Process Method"
                     propertyName="processMethod"/>
          <mdb-input
            v-if="currentJob.type !='GROOVY' && currentJob.processMethod != 'GET' && currentJob.processMethod != 'DELETE'"
            label="Payload" type="textarea" :rows="12" v-model="currentJob.payload"/>
          <div id="ace-editor-container" class="md-form text-left mb-4" v-if="currentJob.type=='GROOVY'">
            <mdb-btn @click="toggleEditorSize" :icon="( editorHeight != 250 ? 'compress-alt' : 'expand-alt')" size="sm"
                     rounded/>
            <ace-editor v-model="currentJob.groovyCode" lang="groovy" @init="editorInit" theme="chrome" width="100%"
                        :height="editorHeight"></ace-editor>
          </div>

          <div v-if="currentJob.id && currentJob.type=='GROOVY' && currentJob.groovyCode == oldGroovyCode">
            <mdb-input label="Test Params" type="textarea" :rows="2" v-model="testParams"/>
          </div>

          <div>
            <mdb-btn @click="saveJob" icon="save" color="success">Save</mdb-btn>
            <mdb-btn v-if="currentJob.id && currentJob.type=='GROOVY' &&  currentJob.groovyCode == oldGroovyCode"
                     @click="testJob" icon="bolt">Test
            </mdb-btn>
            <mdb-btn v-if="currentJob.id && currentJob.type=='PROCESS_ENDPOINT'" @click="testEndpoint" icon="bolt">
              Test
            </mdb-btn>
            <mdb-btn v-if="currentJob.id" @click="showDeleteModal=true" icon="trash" color="danger">Delete</mdb-btn>
          </div>
          <div id="results-scroller">&nbsp;</div>
        </mdb-card-body>
      </mdb-card>
      <mdb-card v-show="showResults" id="results">
        <mdb-card-header class="primary-color text-white">
          <h3>Results
            <mdb-btn @click="showResults = false" size="sm" rounded icon="minus-circle">Close</mdb-btn>
          </h3>
        </mdb-card-header>
        <mdb-card-body class="text-left">
          <pre>
          {{ jobResults }}
          </pre>
          <mdb-btn @click="showResults = false" icon="minus-circle">Close</mdb-btn>
        </mdb-card-body>
      </mdb-card>
    </div>

    <yes-no-modal v-if="showDeleteModal" @yes="deleteJob" @no="showDeleteModal=false"></yes-no-modal>
  </mdb-container>
</template>

<script>
import dataTable from '../common/DataTable'
import {mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbContainer, mdbIcon, mdbInput} from 'mdbvue';
import api from "../../services/groupsPlaceApi";
import gpSelect from "../common/GPSelect";
import YesNoModal from "../common/YesNoModal";
import AceEditor from "vue2-ace-editor"

export default {
  name: 'admin-job',
  components: {
    mdbContainer, mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbInput,
    mdbIcon,
    dataTable,
    gpSelect,
    YesNoModal,
    AceEditor
  },
  mounted() {
    console.log("Mounted.")
  },
  data() {
    return {
      rows: [],
      showDeleteModal: false,
      editorHeight: 250,
      columns: [
        {label: "Name", field: "name"},
        {label: "Description", field: "descr"},
        {label: "Type", field: "type"}
      ],
      methods: [
        {text: "GET", value: "GET"},
        {text: "POST", value: "POST"},
        {text: "PUT", value: "PUT"},
        {text: "DELETE", value: "DELETE"},
      ],
      currentJob: null,
      showJob: false,
      showMain: true,
      jobResults: "",
      showResults: false,
      oldGroovyCode: "",
      testParams: "",
      validTypes: [
        {text: "Groovy Script", value: "GROOVY"},
        {text: "Get an Endpoint & Process Each Result", value: "GET_AND_PROCESS_ENDPOINTS"},
        {text: "Hit an Endpoint", value: "PROCESS_ENDPOINT"}
      ]
    }
  },
  methods: {
    toggleEditorSize() {
      if (this.editorHeight != 250) {
        this.editorHeight = 250
        return
      }
      let el = document.getElementById("ace-editor-container");
      this.editorHeight = window.innerHeight - 300;
      this.$nextTick().then(() => {
        if (el) window.scrollTo(0, el.offsetTop)
      })

    },
    editorInit: function () {
      require('brace/ext/language_tools') //language extension prerequsite...
      require('brace/mode/groovy')
      require('brace/mode/less')
      require('brace/theme/chrome')
      require('brace/ext/searchbox')
      require('brace/theme/textmate')
      require('brace/snippets/groovy') //snippet
    },
    deleteJob: function () {
      this.showDeleteModal = false
      this.$store.dispatch("setExecuting", true)
      api.delete("/dynamicJob/details/" + this.currentJob.id).then(
        (results) => {
          this.showJob = false
          this.showMain = true
          let loc = this.rows.indexOf(this.currentJob)
          this.rows.splice(loc, 1)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 6000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    newJob: function () {
      this.currentJob = {
        id: null,
        name: "",
        descr: "",
        getEndpoint: "",
        groovyCode: "",
        payload: "",
        processEndpoint: "",
        processMethod: "GET",
        type: "PROCESS_ENDPOINT",
      }
      this.showMain = false
      this.showJob = true
      this.showResults = false
      this.oldGroovyCode = ""
    },
    saveJob: function () {
      this.$store.dispatch("setExecuting", true)
      api.post("/dynamicJob/details", this.currentJob).then(
        (results) => {
          if (!this.currentJob.id) this.currentJob.id = results.data.id
          this.$store.dispatch("setDataTableReload")
          this.$notify.success({message: "Saved", timeOut: 3000})
          this.oldGroovyCode = this.currentJob.groovyCode
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 6000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    testJob: function () {
      if (this.currentJob.processMethod != "GET" && this.currentJob.processMethod != "POST") {
        this.$notify.error({message: "Only POST and GET methods are supported for Groovy programs.", timeOut: 6000})
        return
      }
      let url = "/dynamicJob/groovy/" + this.currentJob.name
      if (this.currentJob.processMethod == "GET") {

        if (this.testParams != "") url += "?" + this.testParams
        this.$store.dispatch("setExecuting", true)
        api.get(url).then(
          (results) => {
            try {
              this.jobResults = JSON.stringify(results.data, null, 2)
            } catch (e) {
              this.jobResults = results.data
            }
            this.showResults = true
            this.$nextTick().then(() => {
              let el = document.getElementById("results")
              if (el) {
                window.scrollTo(0, el.offsetTop)
              }
            });
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 6000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      } else {
        let payload = {}
        if (this.testParams != "") {
          try {
            payload = JSON.parse(this.testParams)
          } catch (e) {
            this.$notify.error({message: "Test parameters should be valid JSON.", timeOut: 6000})
          }
        }
        this.$store.dispatch("setExecuting", true)
        api.post(url, payload).then(
          (results) => {
            try {
              this.jobResults = JSON.stringify(results.data, null, 2)
            } catch (e) {
              this.jobResults = results.data
            }
            this.showResults = true
            this.$nextTick().then(() => {
              let el = document.getElementById("results")
              if (el) {
                window.scrollTo(0, el.offsetTop)
              }
            });
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 6000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })

      }

    },
    testEndpoint: function () {
      if (this.currentJob.processMethod != "GET") {
        this.$notify.error({message: "Only POST and GET methods can be tested.", timeOut: 6000})
        return
      }

      this.$store.dispatch("setExecuting", true)
      let url = this.currentJob.processEndpoint.replace("/api/v1","")
      api.get(url).then(
        (results) => {
          try {
            this.jobResults = JSON.stringify(results.data, null, 2)
          } catch (e) {
            this.jobResults = results.data
          }
          this.showResults = true
          this.$nextTick().then(() => {
            let el = document.getElementById("results")
            if (el) {
              window.scrollTo(0, el.offsetTop)
            }
          });
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 6000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },

    cancelShow: function () {
      this.showMain = true
      this.currentJob = null
      this.showJob = false
    },
    openJob: function (row) {
      this.showMain = false
      this.currentJob = row
      this.showJob = true
      this.showResults = false
      this.oldGroovyCode = row.groovyCode
    }

  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
